<template lang="html">
  <div id="footer">
    <div class="footer-bottom">
      <div class="clearfix wrap">
        <ul class="bottom-left">
          <li v-for="(bottomList, index) in bottomLists" :key="index">
            <h3 v-text="bottomList.title"></h3>
            <p v-for="(list, key) in bottomList.lists" :key="key">
              <router-link :to="{path: list.goto}" v-text="list.name"></router-link>
            </p>
          </li>
        </ul>
        <div class="bottom-right clearfix">
          <!-- <div class="code">
            <em><img src="/images/code.png" /></em><br />
            官方微信
          </div> -->
          <div class="contact">
            <h4 v-text="company"></h4>
            <div class="telephone">
              <img src="/images/telephone.png" />
              <span class="phone" v-text="phoneNumber"></span>
            </div>
            <div class="address">地址：<span v-text="address"></span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <a href="http://www.beian.miit.gov.cn" target="_blank"><span v-text="icp"></span></a><br />
      <span v-text="copyright"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bottomLists: [],
      company: '',
      phoneNumber: '',
      address: '',
      copyright: '',
      icp: '',
    }
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData () {
      this.$http.get('/data/common.json')
        .then((response) => {
          if (response.data) {
            this.bottomLists = response.data.bottomLists;
            this.company = response.data.company;
            this.phoneNumber = response.data.phoneNumber;
            this.address = response.data.address;
            this.copyright = response.data.copyright;
            this.icp = response.data.icp;
          }
        }).catch((err)=>{
          console.log(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
#footer {
  .footer-bottom {
    padding-top: 69px;
    height: 266px;
    background: #454857;

    .bottom-left {
      float: left;

      li {
        position: relative;
        float: left;
        margin-right: 100px;

        h3 {
          margin-bottom: 14px;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }

        p {
          margin-bottom: 14px;
        }

        a {
          font-size: 12px;
          color: #B7B7BA;
        }

        &:after {
          display: block;
          position: absolute;
          top: 34px;
          right: -45px;
          content: "";
          width: 1px;
          height: 60px;
          background: #828282;

        }

      }


    }

    .bottom-right {
      float: right;

      .code {
        float: left;
        width: 91px;
        height: 91px;;
        font-size: 12px;
        text-align: center;
        color: #B7B7BA;

        img {
          max-width: 100%;
          height: auto;
          margin-bottom: 10px;
        }
      }

      .contact {
        float: right;
        margin: 0 38px 0 59px;

        h4 {
          margin-bottom: 15px;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }

        .telephone {
          margin-bottom: 15px;
          line-height: 22px;
          font-size: 16px;
          color: #EBEBEB;

          img {
            margin-right: 10px;
          }
        }

        .address {
          font-size: 12px;
          color: #B7B7BA;
        }

      }
    }
  }

  .copyright {
    padding-top: 20px;
    height: 80px;
    line-height: 1.8;
    font-size: 13px;
    text-align: center;
    background: #3A3C49;
    color: #CBCBCB;

    a {
      color: #CBCBCB;
    }
  }
}
</style>
